import { Component, Input, OnInit } from '@angular/core';
import { Apiservice } from '../../../services/api.service';
import { OverlaySideFormService } from '../../shared/overlay-side-form/overlay-side-form.service';
import { Utenteservice } from '../../../services/utente.service';

export class _gruppi {
  id: number;
  gruppo:string;
  azienda:string;
  parent_id:number;
  }


@Component({
  selector: 'app-infousergruppi',
  templateUrl: './infousergruppi.component.html',
  styleUrls: ['./infousergruppi.component.css']
})
export class InfousergruppiComponent implements OnInit {
  @Input() itemData:any
  Gruppi: _gruppi[]=[];
  aziende;//descrizione
  
  constructor(private appService: Apiservice,
    private _overlaySideFormService: OverlaySideFormService,
    public utenteService: Utenteservice) { }

  ngOnInit() {

if(this.itemData){
  let id=this.itemData[0].idTabRif;
  //alert(id)      
  console.log("2")
  this.aziende=this.utenteService.InfoUtenteConnesso.aziende
  console.log(this.itemData);
  this.appService.GetApi("Gruppo/GetAllByUserId/"+id).then((elements:[])=>{
    console.log("ecco i gruppi")
    console.log(elements);
    let id=0
    for(let x=0;x<elements.length;x++){
      id++;
        let xx:_gruppi={
          id:id,
          gruppo:elements[x]['descrizione'],
          parent_id:0,
          azienda:''
        }
        this.Gruppi.push(xx);
        let parent=id;
        let desg=elements[x]['descrizione']
        let kk:[]=elements[x]['listaAziendeAbilitate']
        for(let t=0;t<kk.length;t++){
          id++;
          let xx:_gruppi={
            id:id,
            azienda:kk[t],
            gruppo:desg,
            parent_id:parent
          }
          this.Gruppi.push(xx);
        }
    }
    console.log("ecco i gruppi")
    console.log(this.Gruppi);
  })
}

    this._overlaySideFormService.dataToComponent.subscribe(x=>{
     
    })
  }
  
  inizializza(){
    alert('Inizializzato '+this.itemData[0].IdTabella)
    //
  }
  onClickChiudo(e){
    this._overlaySideFormService.close();
    
  }
}
